// eslint-disable-next-line import/prefer-default-export
export enum DialogWidth {
	'narrow' = 600,
	'normal' = 800,
	'wide' = 1200,
}
